import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

const Footer = () => (
  <div>
    <OutboundLink
      href="https://www.gatsbyjs.org/"
    >
      Visit the Google Analytics plugin page!
    </OutboundLink>
  </div>
)

export default Footer;